import { Card, Row, Typography } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ArrowIcon from '../../assets/icons/arrow-up.svg';
import ProposalService from '../../services/ProposalService';
import { formatToTRY, hasRole } from '../../utils';

const { Text, Title } = Typography;

const RenuewCard = () => {
    const [reneuw, setRenuew] = useState<any>({})

    const [isAdmin, setIsAdmin] = useState(false);
    const [isCentralUser, setIsCentralUser] = useState(false);

    useEffect(() => {
        const isUserAdmin = hasRole('ADMIN');
        setIsAdmin(isUserAdmin);

        const isUserCentralUser = hasRole('CENTRAL_USER');
        setIsCentralUser(isUserCentralUser);
    }, [])

    const fetchProposals = useCallback(async () => {
        try {
            let response: any = await ProposalService.getRenuew();
            setRenuew(response.data)
        } catch (error) {
            console.log(error);
        }
    }, []);

    useEffect(() => {
        fetchProposals()
    }, [])
    return (
        <Card bordered={false} className="dashboard-card dashboard-card-bg-green " bodyStyle={{ padding: 10 }}>
            <div className='dashboard-container'>
                <Row justify={'space-between'}>
                    <div className='card-value'>
                        {formatToTRY(reneuw?.total, false)}  ₺
                    </div>
                    <img src={ArrowIcon} height={20} width={20} />
                </Row>
                <div>
                    <Title style={{ fontWeight: 'bold' }} className='mb-0' level={3}>{(isAdmin || isCentralUser) ? "İş Ortağı Ödemeleri" : "Gelir Toplamı"}</Title>
                    <Text style={{ fontWeight: 300, fontSize: 18, color: '#001433' }} className="m-0">+{formatToTRY(reneuw?.last6Month, false)} ₺  Son 6 Ay</Text>
                </div>
            </div>
        </Card>
    )
}

export default RenuewCard